var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"dense":"","loading":_vm.isLoading,"headers":_vm.headers,"items":_vm.getItems}})}
var staticRenderFns = []

export { render, staticRenderFns }